export default __webpack_public_path__ + "static/media/productslide-2.5baa8847.jpg";